var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAreaBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_31389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 0H4.75C3.49022 0 2.28204 0.500445 1.39124 1.39124C0.500445 2.28204 0 3.49022 0 4.75L0 14.25C0 15.5098 0.500445 16.718 1.39124 17.6088C2.28204 18.4996 3.49022 19 4.75 19H14.25C15.5098 19 16.718 18.4996 17.6088 17.6088C18.4996 16.718 19 15.5098 19 14.25V4.75C19 3.49022 18.4996 2.28204 17.6088 1.39124C16.718 0.500445 15.5098 0 14.25 0ZM18.1094 14.25C18.1082 15.2732 17.7012 16.2542 16.9777 16.9777C16.2542 17.7012 15.2732 18.1082 14.25 18.1094H4.75C3.72679 18.1082 2.74583 17.7012 2.02231 16.9777C1.29879 16.2542 0.891804 15.2732 0.890625 14.25V4.75C0.891804 3.72679 1.29879 2.74583 2.02231 2.02231C2.74583 1.29879 3.72679 0.891804 4.75 0.890625H14.25C15.2732 0.891804 16.2542 1.29879 16.9777 2.02231C17.7012 2.74583 18.1082 3.72679 18.1094 4.75V14.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5078 12.8778L6.12216 5.49219H9.0437V4.60156H4.60156V9.0437H5.49219V6.12186L12.8781 13.5078H9.9563V14.3984H14.3984V9.9563H13.5078V12.8778Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_31389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaBlack);
export default __webpack_public_path__ + "static/media/area_black.eaefae252466cebd8a21ece89ebed22b.svg";
export { ForwardRef as ReactComponent };